// extracted by mini-css-extract-plugin
export default {"headerBar":"MK-z","pointsSection":"NK-z","goToDashboard":"OK-z"};